import module from 'guest/module.js'
import template from './template.html'

class GuestServiciosComponent {
  constructor ($state) {
    this.$state = $state
    this.fechaInicial = null
    this.fechaFinal = null
    this.idMoneda = null
    this.data = null
    this.monedas = null
  }

  $onInit () {
    this.catalogos = {
      monedas: this.monedas,
    }
    this.filters = {
      inicio: this.fechaInicial,
      fin: this.fechaFinal,
      moneda: this.idMoneda,
    }
  }

  $search () {
    this.$state.go(this.$state.current, {
      inicio: this.filters.inicio.toYMD(),
      fin: this.filters.fin.toYMD(),
      moneda: this.filters.moneda,
    }, {reload: true})
  }
}

module.component('guestServicios', {
  controller: GuestServiciosComponent,
  template,
  bindings: {
    fechaInicial: '<',
    fechaFinal: '<',
    idMoneda: '<',
    data: '<',
    monedas: '<',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/servicios/component.js